<template>
    <div>
        <div class="choose-panel">
            <span v-if="buttonType === 'text'" class="choose-text" :style="{width:width}" :class="{active:isShowModel}" @click="expand">{{title}}<span class="num">({{counts}})</span></span>
            <span v-if="buttonType === 'button'" class="choose-button" :class="{active:isShowModel}" @click="expand">
                <i class="el-icon-goods"></i>
                <span class="num" v-if="count > 0">{{counts}}</span>
            </span>
        </div>
        <ip-choose-model :visible="isShowModel" :i18n-text="i18nText" :title="title" :count="count" :list="list" :is-show-img="isShowImg"
        @clear="handleClear" @search="handleSearch" @delete-item="handleDeleteItem" @delete-sub-item="handleDeleteSubItem">
            <template slot="operate">
                    <slot name="operate"></slot>   
            </template> 
        </ip-choose-model>
    </div>
</template>

<script>
import ipChooseModel from './IpChooseModel'
export default {
    name:'ipDataChoose',
    components:{
        ipChooseModel
    },
    props:{
        buttonType:{type:String,default:'text'},
        count:{type:Number,default:0},
        title:{type:String,default:''},
        width:{type:String,default:''},
        list:{type:Array,default(){return[]}},
        isShowImg:{type:Boolean,default:false},
        i18nText:{type:Object,default(){return {}}},
        isShowModel:{type:Boolean,default:false}
    },
    data(){
        return{
        }
    },
    computed:{
        counts(){
            var temp = ''
            if(this.count > 99){
                temp = '99+'
            }else{
                temp =this.count.toString();
            }
            return temp
        },
    },
    methods:{
        expand(){
            this.$emit('enpand',this.isShowModel)
        },
        handleClear(){
            this.$emit('clear');
        },
        handleDeleteItem(index){
            this.$emit('delete-item',index);
        },
        handleSearch(query){
            this.$emit('search',query);
        },
        handleDeleteSubItem(item,index){
            this.$emit('delete-sub-item',item,index);
        }
    }
}
</script>

<style lang="scss" scoped>
.choose-panel{
    position: fixed;
    bottom:20%;
    right: 25px;
    z-index: 999;
    .choose-text{
        display:inline-block;
        width: 35px;
        line-height: 18px;
        color: #ffffff;
        font-size: $sm-font-size;
        background: rgba($color: #000000, $alpha: 0.6);
        border-radius: 3px;
        padding: 8px 5px;
        box-sizing: border-box;
        cursor: pointer;
        text-align: center;
        .num{
            font-size: $xs-font-size;
        }
    }
    .choose-button{
        display:inline-block;
        width: 50px;
        text-align: center;
        line-height: 50px;
        height: 50px;
        color: #fff;
        position: relative;
        border-radius: 3px;
        background: rgba($color: #000000, $alpha: 0.6);
        i{
            font-size: 30px;
            vertical-align: middle;
        }
        .num{
            position: absolute;
            right:4px;
            top: 4px;
            background: red;
            font-size: $xs-font-size;
            border-radius: 50%;
            height: 18px;
            padding: 0 4px;
            line-height: 18px;
        }
    }
    .active{
        background: $theme-color;
    }
}
</style>

